const RedemptionDaysLeft = () => {
  const daysUntilEnd = Math.floor((1638820800000 - new Date().getTime()) / (1000 * 60 * 60 * 24)) + 1;
  
  return (
    daysUntilEnd >= 0 ? (
      <span>Mixpass redemption ends on Monday on Dec 6th, 2021 at 3pm ET. Redeeem yours now!</span>
    ) : (
      <span>Mixpass redemption ended on Monday on Dec 6th, 2021 at 3pm ET.</span>
    )
  )
}

export default RedemptionDaysLeft;
